import http from '@/requests/http'

class ExtensionStatusDataAnalysis {
  static findAll (params) {
    return http.post('extension-status-data-analysis/index', params)
  }
  static viewExtension (params) {
    return http.post('extension-status-data-analysis', params)
  }
}

export default ExtensionStatusDataAnalysis
